import { Router } from '@zenlayer/portal-utils';
import { routes } from './routes';

export default () => {
  return <Router routes={routes} params={{}} />;
};
